export default "__VITE_ASSET__4a85ffe5__"